import { Link } from 'react-router-dom';
import type { Category } from '@/types';

interface CategoryCardProps {
  category: Category;
  compact?: boolean;
}

export default function CategoryCard({ category, compact = false }: CategoryCardProps) {
  if (compact) {
    return (
      <Link
        to={`/category/${category.slug}`}
        className="group flex items-center gap-3 px-4 py-3 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 no-underline"
      >
        <span className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
          <i className={`${category.icon} text-primary-600 text-base`}></i>
        </span>
        <div className="min-w-0">
          <h4 className="text-sm font-medium text-foreground-900 whitespace-nowrap group-hover:text-primary-600 transition-colors">
            {category.name}
          </h4>
          <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">{category.description}</p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/category/${category.slug}`}
      className="group flex flex-col rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 no-underline"
    >
      <div className="relative overflow-hidden aspect-[16/10]">
        <img
          src={category.image}
          alt={category.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
        <div className="absolute bottom-3 left-3 flex items-center gap-2">
          <span className="w-8 h-8 rounded-lg bg-white/20 backdrop-blur-sm flex items-center justify-center">
            <i className={`${category.icon} text-white text-base`}></i>
          </span>
          <span className="text-white font-heading font-semibold text-sm">{category.name}</span>
        </div>
      </div>
      <div className="p-4">
        <p className="text-sm text-foreground-500 line-clamp-2">{category.description}</p>
      </div>
    </Link>
  );
}